import React, { useState,useEffect } from 'react';
import TopTitle from './TopTitle';
import {comma,instance} from './common';
import Pagination from "react-js-pagination";
import Bottom_menu from './Bottom_menu';

function Product({history}){

    const blockItems = {
        display:'inline-block',
        width:'100px'
    }

    const [activePosition, setActive] = useState('전체');
    const activeArray = [
        '전체',
        '카테고리A',
        '카테고리B',
        '카테고리C',
    ];

    const activeClick = (e) => {
        const {name} = e.target.dataset;
        setActive(name);
    }

    const [data, setData] = useState([]);
    const ppp = 4;
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);


    const [order, setOrder] = useState('pr_id');

    useEffect(() => {

        let obj = {
            page: page,
            ppp: ppp,
            order: order,
            keyword : '',
            value : '',
            cate:activePosition
        }

        const fetchData = async () => {
            instance.post('/product/app-all', obj).then(function (res) {
                setData(res.data.rows);
                setTotal(res.data.totalCount);
            });

        };
        fetchData();
    }, [page, ppp, order,activePosition]);


    const pageChange = (pageNumber) => {
        setPage(pageNumber);
    }

    console.log('data : ', data)

    return (
        <>
            <TopTitle title="상품" />
            <div className="container text-center" style={{overflow:'scroll'}}>
                <div className="row p-0 border-bottom" style={{minWidth:'2000px'}}>
                    {
                        activeArray.map((v,i) => 
                            v == activePosition
                            ?<div key={i} className="cateItems active pt-2 pb-2 font-weight-bold" style={blockItems} data-name={v} onClick={activeClick}>{v}</div>
                            :<div key={i} className="cateItems pt-2 pb-2 font-weight-bold" style={blockItems} data-name={v} onClick={activeClick}>{v}</div>
                            
                        )
                    }
                </div>
            </div>

            <div className="container mt-3 mb-3" onChange={(e) => setOrder(e.target.value)}>
                <select className="form-control d-inline-block" style={{width:'auto',borderRadius:'10px'}}>
                    <option value="pr_id">최신순</option>
                    <option value="pr_nochul">추천순</option>
                </select>
            </div>


            <div className="container" style={{paddingBottom:'100px'}}>
                <div className="row p-0">
                    {
                        data.map((v,i) => 
                            (i % 2 == 1)
                            ?
                            <div className="col-6 pr-0 mb-2" key={v.pr_id} onClick={() => history.push('/product-detail?pr_id='+v.pr_id)}>
                                <div className="product-items-bg" style={{background:'url(\''+v.pr_img+'\')'}}></div>
                                <h4 className="font-weight-bold text-secondary mt-2 mb-0">{v.pr_name}</h4>
                                <h4 className="font-weight-bold mt-2 " style={{color:'#2F79D9'}}>{comma(v.daeri_price)} 원</h4>
                            </div>
                            :
                            <div className="col-6 pl-0 mb-2" key={v.pr_id} onClick={() => history.push('/product-detail?pr_id='+v.pr_id)}>
                                <div className="product-items-bg" style={{background:'url(\''+v.pr_img+'\')'}}></div>
                                <h4 className="font-weight-bold text-secondary mt-2 mb-0">{v.pr_name}</h4>
                                <h4 className="font-weight-bold mt-2 " style={{color:'#2F79D9'}}>{comma(v.daeri_price)} 원</h4>
                            </div>
                        )
                    }
                </div>
                <div className="text-center">
                    <Pagination
                        activePage={page}
                        itemsCountPerPage={10}
                        totalItemsCount={total}
                        pageRangeDisplayed={10}
                        onChange={pageChange}
                    />
                </div>
                <div className="pb-3">
                    <span className="pt-3 pb-3 btn btn-primary d-block" onClick={() => history.push('/product-cart')} >장바구니</span>
                </div>
            </div>
            <Bottom_menu />
        </>
    )
}

export default Product;